import React from 'react';
import { Link } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { ArrowRight, Robot, GitBranch, CurrencyDollar, HardDrives } from '@phosphor-icons/react';

const services = [
  {
    icon: <Robot size={48} weight="duotone" className="text-[#0052FF]" />,
    title: 'Agentic AI',
    path: '/services/agentic-ai',
    description: 'Deploy autonomous AI agents that learn, adapt, and execute complex workflows. Our AI-Powered DevSecOps integrates seamlessly into your CI/CD pipeline for proactive security and operational excellence.',
  },
  {
    icon: <GitBranch size={48} weight="duotone" className="text-[#0052FF]" />,
    title: 'DevOps Automation',
    path: '/services/devops-automation',
    description: 'End-to-end DevOps automation with intelligent testing suites. From pipeline orchestration to comprehensive APM tracking, we deliver operational reliability at scale.',
  },
  {
    icon: <CurrencyDollar size={48} weight="duotone" className="text-[#0052FF]" />,
    title: 'Cloud & FinOps',
    path: '/services/cloud-finops',
    description: 'Maximize cloud ROI with granular cost analytics and automated optimization. Our FinOps platform provides real-time visibility into cloud spend across all providers.',
  },
  {
    icon: <HardDrives size={48} weight="duotone" className="text-[#0052FF]" />,
    title: 'Infrastructure & Compute',
    path: '/services/infrastructure-compute',
    description: 'Scalable infrastructure services from bare-metal to serverless. Deploy globally with our dual-region architecture spanning the USA and India.',
  },
];

export default function ServicesPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="services-page">
      <Header />
      <div className="pt-[72px]">
        {/* Hero */}
        <div className="bg-[#0B132B] py-20 md:py-28">
          <div className="w-full px-6 md:px-10 lg:px-16 xl:px-24">
            <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#10B981] mb-3">Services</p>
            <h1 className="text-4xl sm:text-5xl tracking-tighter font-black text-white" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Our Services
            </h1>
            <p className="text-lg md:text-xl text-slate-300 mt-4 max-w-3xl" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
              Leverage our extensive Cloud and DevOps expertise to architect, execute, and manage your cloud journey with cutting-edge technologies.
            </p>
          </div>
        </div>

        {/* Services Grid */}
        <div className="py-20 md:py-28">
          <div className="w-full px-6 md:px-10 lg:px-16 xl:px-24">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {services.map((svc) => (
                <Link
                  key={svc.path}
                  to={svc.path}
                  className="block p-8 lg:p-10 border border-slate-200 hover:border-[#0052FF]/40 hover:shadow-lg transition-all duration-200 group"
                  data-testid={`service-card-${svc.path.split('/').pop()}`}
                >
                  <div className="mb-6">{svc.icon}</div>
                  <h3 className="text-xl sm:text-2xl font-semibold text-[#0B132B] mb-4 group-hover:text-[#0052FF] transition-colors" style={{ fontFamily: 'Chivo, sans-serif' }}>
                    {svc.title}
                  </h3>
                  <p className="text-base leading-relaxed text-[#475569] mb-6" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
                    {svc.description}
                  </p>
                  <span className="inline-flex items-center gap-2 text-[#0052FF] text-base font-semibold group-hover:gap-3 transition-all duration-200">
                    Learn More <ArrowRight size={16} weight="bold" />
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
